import React from 'react';
import { MultiSelect } from '@mantine/core';
import { Pane, Select, TextInput, Paragraph, IconButton } from 'evergreen-ui';
import { FormikProps } from 'formik';

// Limited prop types
export type InviteFieldProps = Record<string, any> &
  Pick<FormikProps<any>, 'handleChange' | 'handleBlur' | 'setFieldValue'>;

const InviteField = ({
  name,
  email,
  role,
  credentials,
  roleOptions,
  credentialOptions,
  onAddClick,
  onRemoveClick,
  handleChange,
  handleBlur,
  setFieldValue,
  canRemove,
  canAdd,
  validationError,
  wasCreated,
}: InviteFieldProps) => {
  // Mantine MultiSelect requires special handler for interface with Formik
  const handleCredentialsChange = (values: any[]) => {
    setFieldValue(`${name}.credentials`, values);
  };

  return (
    <Pane display="flex" flexDirection="column" marginBottom={8}>
      <Pane flex="1" display="flex" flexDirection="row" alignItems="center">
        <IconButton
          intent="success"
          appearance="minimal"
          icon="plus"
          type="button"
          marginRight={8}
          disabled={!canAdd}
          onClick={(e: any) => {
            e.preventDefault();
            onAddClick();
          }}
        />
        <TextInput
          required
          isInvalid={!!validationError}
          name={`${name}.email`}
          value={email}
          type="email"
          placeholder="email@example.com"
          onChange={handleChange}
          onBlur={handleBlur}
          flex={14}
        />
        <Select
          name={`${name}.roles[0]`}
          value={role}
          flex={7}
          onChange={handleChange}
        >
          {/* @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message */}
          <option value={null}>N/A</option>
          {roleOptions.map(({ label, value }: any) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
        <MultiSelect
          value={credentials}
          style={{ flex: 11 }}
          onChange={handleCredentialsChange}
          data={credentialOptions}
          onBlur={handleBlur}
          placeholder="Select Credentials"
        />

        <IconButton
          appearance="minimal"
          intent="danger"
          icon="cross"
          type="button"
          marginLeft={8}
          disabled={!canRemove}
          onClick={onRemoveClick}
        />
      </Pane>
      {validationError && (
        <Paragraph color="danger" paddingLeft={40} marginTop={4}>
          {validationError.message}
        </Paragraph>
      )}

      {wasCreated && (
        <Paragraph color="success" paddingLeft={40} marginTop={4}>
          Invite successfully sent
        </Paragraph>
      )}
    </Pane>
  );
};

export default InviteField;
